export default __webpack_public_path__ + "static/media/thailand.e84065a9.svg";